<template>
  <div>
    <b-modal
      v-if="distance.related_distances"
      :id="'bv-modal-edit' + index"
      class="z-index"
      title="Редактировать комбо дистанций"
      hide-footer
      @hidden="resetModal"
      @show="updateSelected"
    >
      <div class="distance_wrapper">
        <label
          class="distance_label"
          for="checkComboEdit"
          >Название комбо</label
        >
        <b-form-input
          id="checkComboEdit"
          v-model="distance.name"
          placeholder="Название комбо"
          label="Название комбо"
          vs-placeholder="Название комбо"
          class="w-full"
        />
      </div>
      <div
        id="combo-multi-registration"
        class="distance_wrapper distance_double__wrapper"
      >
        <b-form-checkbox
          id="checkDoubleEdit"
          v-model="distance.is_multi_registration"
          checked="false"
          class="custom-control-primary"
          name="check-view"
          switch
        />
        <label
          class="distance_double__label"
          for="checkDoubleEdit"
          >Отключить проверку дублей?</label
        >
        <b-tooltip target="combo-multi-registration">
          Отключение дубликатов не будет влиять на комбо, в которых есть
          эстафеты
        </b-tooltip>
      </div>

      <div class="distance_wrapper">
        <div
          v-b-toggle.comboEdit
          class="distance_form__button"
          @click="toggleCollapsed('comboEdit')"
        >
          Выбери дистанции
          <span>{{ collapsedStates.comboEdit ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="comboEdit">
          <b-form-checkbox-group
            v-for="(distance, index) in filteredDistances"
            :key="index"
            v-model="selectedDistances"
          >
            <div
              :id="`checkbox-tooltip-${index}`"
              class="d-inline-block"
              tabindex="0"
            >
              <b-form-checkbox
                :id="`checkbox-tooltip-${index}`"
                :key="index"
                class="mt-1 mr-1"
                :value="distance"
                :disabled="isRestricted"
              >
                {{ distance.name }}
              </b-form-checkbox>
            </div>
            <b-tooltip
              v-if="isRestricted"
              :target="`checkbox-tooltip-${index}`"
              triggers="hover"
            >
              В данной дистанции есть регистрации
            </b-tooltip>
          </b-form-checkbox-group>
        </b-collapse>
      </div>

      <div class="distance_wrapper">
        <div
          v-b-toggle.discountComboEdit
          class="distance_form__button"
          :class="{ distance_form__combo: collapsedStates.discountComboEdit }"
          @click="toggleCollapsed('discountComboEdit')"
        >
          Выбери скидку
          <span>{{ collapsedStates.discountComboEdit ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="discountComboEdit">
          <discount-switcher
            :is-restricted="isRestricted"
            :discount-is-percent="distance.combo_discount_is_percent"
            :value="+distance.combo_discount_value"
            @discountType="
              value => (distance.combo_discount_is_percent = value)
            "
            @input="value => (distance.combo_discount_value = value)"
          />
        </b-collapse>
      </div>
      <span
        id="save-button"
        class="d-inline-block button-container"
      >
        <b-button
          id="tooltip-target-1"
          type="submit"
          variant="primary"
          class="mr-1 combo-button"
          :disabled="selectedDistances.length < 2"
          @click="updateSport"
        >
          Сохранить
        </b-button>
      </span>
      <b-tooltip
        v-if="selectedDistances.length < 2"
        target="save-button"
      >
        Комбо должно содержать минимум 2 дистанции
      </b-tooltip>
    </b-modal>

    <!-- Редактировать дистанцию -->
    <b-modal
      v-else
      :id="'bv-modal-edit' + index"
      class="z-index"
      title="Редактировать дистанцию"
      ok-only
      ok-title="Сохранить"
      @ok="updateSport"
      @show="updateSelected"
    >
      <div class="distance_wrapper">
        <label
          for="distanceName"
          class="distance_label"
          >Имя дистанции</label
        >
        <b-form-input
          v-model="distance.name"
          placeholder="Имя дистанции"
          label="Имя дистанции"
          vs-placeholder="Имя дистанции"
          class=""
        />
      </div>

      <div class="distance_wrapper distance_double__wrapper">
        <b-form-checkbox
          id="checkDouble"
          v-model="distance.is_multi_registration"
          checked="false"
          class="custom-control-primary"
          name="check-view"
          switch
        />
        <label
          class="distance_double__label"
          for="checkDouble"
          >Отключить проверку дублей?</label
        >
      </div>
      <div class="distance_wrapper distance_double__wrapper">
        <b-form-checkbox
          id="checkPatronymicRequiredEdit"
          v-model="distance.is_patronymic_required"
          checked="false"
          class="custom-control-primary"
          name="check-patronymic-required"
          switch
        />
        <label
          class="distance_double__label"
          for="checkPatronymicRequiredEdit"
          >Отчество обязательно?</label
        >
      </div>

      <!--   Формат дистанции   -->
      <div class="distance_wrapper distance_format">
        <div
          v-b-toggle.participationFormat
          class="distance_form__button"
          @click="toggleCollapsed('participationFormat')"
        >
          <span class="distance_title">Формат участия</span>
          <span>{{ collapsedStates.participationFormat ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="participationFormat">
          <div
            v-for="(format, index) in sport_formats"
            :key="'format' + index"
            class="distance_title"
          >
            <b-form-radio
              v-model="distance.format"
              name="sport_format"
              class="mr-6"
              :value="format"
            >
              {{ format }}
            </b-form-radio>
          </div>
        </b-collapse>
        <template v-if="distance.format === 'Лично'">
          <div>
            <distance-block
              :distance="distance"
              :mode="'Лично'"
              :start="start"
            />
            <div
              v-b-toggle.personalGroups
              class="distance_form__button"
              @click="toggleCollapsed('personalGroups')"
            >
              <span class="distance_title">
                Группы - {{ distance.groups.length }}
              </span>
              <span>{{ collapsedStates.personalGroups ? '🔼' : '🔽' }}</span>
            </div>
            <b-collapse id="personalGroups">
              <template v-for="(group, index) in distance.groups">
                <group
                  :key="'group' + index"
                  :groups="distance.groups"
                  :group="group"
                  :group-index="index"
                  :is-restricted="isRestricted"
                  @update-group="updateGroup"
                  @delete-group="deleteGroup"
                />
              </template>
              <div
                id="button-tooltip"
                class="inline-block mt-2 group-buttons"
                tabindex="0"
              >
                <group-templates @select="addGroupsFromTemplate" />
                <b-button
                  size="small"
                  :disabled="isRestricted"
                  @click="addGroup"
                >
                  Добавить группу
                </b-button>
              </div>
              <b-tooltip
                v-if="isRestricted"
                target="button-tooltip"
                triggers="hover"
              >
                В данной дистанции есть регистрации
              </b-tooltip>
            </b-collapse>
          </div>
        </template>

        <template v-if="distance.format === 'Эстафета'">
          <distance-block
            :distance="distance"
            :start="start"
          />
          <div class="mt-3 mb-3 mt-3">Этапы ({{ distance.stages.length }})</div>
          <stage-block
            :stages="distance.stages"
            :is-restricted="isRestricted"
            @deleteStage="deleteStage"
          />
          <div
            id="add-stage-button-tooltip"
            class="d-inline-block"
            tabindex="0"
          >
            <b-button
              class="mt-3"
              size="small"
              :disabled="isRestricted"
              @click="addStage"
            >
              Добавить этап
            </b-button>
          </div>
          <b-tooltip
            v-if="isRestricted"
            target="add-stage-button-tooltip"
            triggers="hover"
          >
            В данной дистанции есть регистрации
          </b-tooltip>

          <div class="mt-3 mb-3 mt-3">
            Группы ({{ distance.groups.length }})
          </div>
          <template v-for="(group, index) in distance.groups">
            <group
              :key="'group' + index"
              :groups="distance.groups"
              :group="group"
              :group-index="index"
              :distance-format="distance.format"
              :stages="distance.stages"
              @update-group="updateGroup"
              @delete-group="deleteGroup"
            />
          </template>
          <div
            id="add-group-button-tooltip"
            class="inline-block mt-2 group-buttons"
            tabindex="0"
          >
            <group-templates @select="addGroupsFromTemplate" />
            <b-button
              size="small"
              @click="addGroup"
            >
              Добавить группу
            </b-button>
          </div>
          <b-tooltip
            v-if="isRestricted"
            target="add-group-button-tooltip"
            triggers="hover"
          >
            В данной дистанции есть регистрации
          </b-tooltip>
        </template>
      </div>
      <template>
        <div>
          <div class="distance_wrapper">
            <div
              v-b-toggle.additionalFields
              class="distance_form__button"
              @click="toggleCollapsed('additionalFields')"
            >
              Дополнительные поля - {{ distance.additional_fields.length }}
              <span>{{ collapsedStates.additionalFields ? '🔼' : '🔽' }}</span>
            </div>

            <b-collapse id="additionalFields">
              <template
                v-for="(additionalField, index) in distance.additional_fields"
              >
                <additionalField
                  :key="'additionalField' + index"
                  :distance="distance"
                  :field="additionalField"
                  :is-restricted="isRestricted"
                  :field-index="index"
                  @update-field="updateField"
                  @delete-field="deleteField"
                />
              </template>
              <div
                id="additional-field-button-tooltip"
                class="d-inline-block"
                tabindex="0"
              >
                <b-button
                  class="mt-1"
                  size="small"
                  :disabled="isRestricted"
                  @click="addField"
                >
                  Добавить доп поле
                </b-button>
              </div>
              <b-tooltip
                v-if="isRestricted"
                target="additional-field-button-tooltip"
                triggers="hover"
              >
                В данной дистанции есть регистрации
              </b-tooltip>
            </b-collapse>
          </div>
        </div>
      </template>
      <div class="distance_wrapper">
        <div
          v-b-toggle.discountsEdit
          class="distance_form__button"
          @click="toggleCollapsed('discountsEdit')"
        >
          <div>Скидки по возрасту</div>
          <span>{{ collapsedStates.discountsEdit ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="discountsEdit">
          <div>
            <div class="discount__items">
              <div
                v-for="(item, i) in distance.discounts"
                :key="'discount_' + i"
                class="discount__item"
              >
                <div
                  v-if="!disabledDiscounts.includes(item.id)"
                  class="discount__item-del"
                  @click="distance.discounts.splice(i, 1)"
                >
                  <svg
                    width="10"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 320 512"
                    class="delete-icon"
                  >
                    <path
                      d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                    />
                  </svg>
                </div>
                <label
                  for=""
                  class="distance_label"
                  >Возраст от</label
                >
                <b-form-input
                  v-model.number="item.c_from"
                  type="number"
                  no-wheel
                  placeholder="Возраст от"
                  class="distance_input__description"
                />
                <label
                  for=""
                  class="distance_label"
                  >Возраст до</label
                >
                <b-form-input
                  v-model.number="item.c_to"
                  type="number"
                  no-wheel
                  placeholder="Возраст до"
                  class="distance_input__description"
                />
                <discount-switcher
                  :discount-is-percent="item.percent"
                  :value="+item.value"
                  @discountType="value => (item.percent = value)"
                  @input="value => (item.value = value)"
                />
              </div>
            </div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mt-1"
              @click="
                distance.discounts.push({
                  c_to: null,
                  c_from: null,
                  value: null,
                  percent: false,
                })
              "
            >
              Добавить скидку
            </b-button>
          </div>
        </b-collapse>
      </div>

      <div class="distance_wrapper">
        <div
          v-b-toggle.detailed_description
          class="distance_form__button"
          @click="toggleCollapsed('detailed_description')"
        >
          <div>Полное описание дистанции</div>
          <span>{{ collapsedStates.detailed_description ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="detailed_description">
          <admin-quill-editor
            ref="detailed_description_editor"
            v-model="distance.detailed_description"
            :options="quillEditorOptions"
            @change="onEditorChange($event)"
          />
        </b-collapse>
      </div>

      <div class="distance_wrapper">
        <div
          v-b-toggle.scheme
          class="distance_form__button"
          @click="toggleCollapsed('scheme')"
        >
          <div>Схема проезда дистанции</div>
          <span>{{ collapsedStates.scheme ? '🔼' : '🔽' }}</span>
        </div>
        <b-collapse id="scheme">
          <div class="">
            <div class="">
              <!-- Загрузка изображения схемы -->
              <b-form-group label="Загрузка изображения схемы">
                <file-uploader
                  :key="'distanceSchemeFile' + index + '_' + (distance.scheme_image_id || 'new')"
                  :default="distance.scheme_image"
                  :value="distance.scheme_image_id"
                  @input="val => {
                    distance.scheme_image_id = val
                    if (!val) {
                      distance.scheme_image = null
                    }
                  }"
                  @updatePhotos="file => (distance.scheme_image = file)"
                />
              </b-form-group>

              <!-- iframe карты -->
              <b-form-group
                label="Вставьте iframe карты (например, Google или Яндекс)"
              >
                <a
                  href="https://yandex.ru/map-constructor/"
                  target="_blank"
                >
                  Конструктор схемы
                </a>

                <b-form-textarea
                  v-model="distance.scheme_frame"
                  placeholder="<iframe ...></iframe>"
                  rows="4"
                />

                <b-button
                  variant="primary"
                  class="mt-1"
                  @click="showIframePreview = !showIframePreview"
                >
                  {{ showIframePreview ? 'Скрыть' : 'Предпросмотр' }}
                </b-button>

                <div
                  v-if="showIframePreview"
                  class="iframe-preview mt-2"
                >
                  <div v-html="distance.scheme_frame"></div>
                </div>
              </b-form-group>
            </div>
          </div>
        </b-collapse>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormInput,
  BFormCheckbox,
  BButton,
  BModal,
  BFormRadio,
  BFormCheckboxGroup,
  VBPopover,
  BFormGroup,
  BTooltip,
  VBToggle,
  BCollapse,
  BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { v4 as uuidv4 } from 'uuid'
import Vue from 'vue'
import GroupTemplates from '@/views/starts/GroupTemplates.vue'
import DistanceBlock from './DistanceBlock.vue'
import Group from './Group.vue'
import StageBlock from './StageBlock.vue'
import AdditionalField from './AdditionalField.vue'
import DiscountSwitcher from '@/global-components/DiscountSwitcher.vue'
import FileUploader from '@/global-components/FileUploader.vue'
import { buildQuillOptions } from '@/plugins/quill-config'

export default {
  name: 'EditDistance',
  components: {
    StageBlock,
    Group,
    DistanceBlock,
    GroupTemplates,
    BFormInput,
    BFormCheckbox,
    BButton,
    BModal,
    BFormRadio,
    BFormCheckboxGroup,
    AdditionalField,
    BTooltip,
    DiscountSwitcher,
    BFormGroup,
    BCollapse,
    FileUploader,
    BFormTextarea,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
    'b-toggle': VBToggle,
  },
  props: [
    'age_groups',
    'select_kinds_sport',
    'sport',
    'index',
    'start',
    'isRestricted',
    'schemeFile'
  ],
  data() {
    return {
      distance: {},
      groups: [],
      slotDisable: false,
      kind_sport: '',
      activeSelectSport: false,
      new_kind_sport: '',
      sport_formats: ['Лично', 'Эстафета'],
      selectedDistances: [],
      disabledCombo: [],
      disabledGroups: [],
      disabledStages: [],
      disabledDiscounts: [],
      templateGroups: [],
      schemeRouteFile: null,
      scheme_image_id: null,
      scheme_frame: '',
      showIframePreview: false,
      collapsedStates: {
        participationFormat: false,
        personalGroups: false,
        additionalFields: false,
        discountsEdit: false,
        comboEdit: false,
        discountComboEdit: false,
        detailed_description: false,
        scheme: false,
      },
    }
  },
  computed: {
    filteredDistances() {
      return this.select_kinds_sport.filter(item => !item.related_distances)
    },
    quillEditorOptions() {
      return buildQuillOptions({
        startId: this.start?.id,
        requireStartPick: false,
        includeStartInShortcode: false,
      })
    },
  },

  watch: {
    'distance.format': {
      handler(newValue) {
        if (newValue === 'Лично') {
          this.distance.groups = this.distance.groups.filter(
            group => group.format !== 'Minimum' && group.format !== 'Combined',
          )
        } else if (newValue === 'Эстафета') {
          if (this.templateGroups.length) {
            const nedeedGroups = this.templateGroups.filter(
              group =>
                group.format === 'Minimum' || group.format === 'Combined',
            )
            this.distance.groups = this.distance.groups.concat(nedeedGroups)
          }
        }
      },
    },
  },
  created() {
    this.transformSelectedDistances()

    if (this.sport.groups) {
      this.transformSportGroupsFields()
    }
    this.distance = JSON.parse(JSON.stringify(this.sport))
    this.ensurePatronymicRequiredField()
  },
  mounted() {},
  methods: {
    ensurePatronymicRequiredField() {
      // Backward-compatible default for old distances where the backend doesn't return the field yet
      if (typeof this.distance?.is_patronymic_required !== 'boolean') {
        this.$set(this.distance, 'is_patronymic_required', false)
      }
    },
    deleteStage(stageToDelete) {
      const index = this.distance.stages.findIndex(
        stage => stage === stageToDelete,
      )
      if (index !== -1) {
        this.distance.stages.splice(index, 1)
      }
    },
    onEditorChange(event) {
      event.quill
    },
    addStage() {
      this.distance.stages.push({
        uuid: uuidv4(),
        name: null,
        sex: null,
        additional_fields: [],
        kind_of_sport_id: null,
        stage_length: null,
      })
    },
    toggleCollapsed(collapseId) {
      this.collapsedStates[collapseId] = !this.collapsedStates[collapseId]
    },
    addGroupsFromTemplate(groups) {
      if (this.templateGroups.length !== 0) {
        const { template_id } = this.templateGroups[0]
        this.distance.groups = this.distance.groups.filter(
          group => group.template_id !== template_id,
        )
      }
      this.templateGroups = groups
      if (this.distance.format === 'Лично') {
        const filteredGroups = groups.filter(
          group =>
            group.format === 'Male' ||
            group.format === 'Female' ||
            group.format === 'Any',
        )
        this.distance.groups = this.distance.groups.concat(filteredGroups)
      } else if (this.distance.format === 'Эстафета') {
        this.distance.groups = this.distance.groups.concat(groups)
      }
    },
    updateDiscountType(value) {
      this.distance.combo_discount_is_percent = value
    },
    updateDiscountValue(value) {
      this.distance.combo_discount_value = value
    },
    updateSelected() {
      this.distance = JSON.parse(JSON.stringify(this.sport))
      this.transformSelectedDistances()
      this.ensurePatronymicRequiredField()
    },
    addGroup() {
      if (this.distance.format === 'Лично') {
        this.distance.groups.push({
          name: null,
          age_from: null,
          age_to: null,
          age_reference_date: null,
        })
      } else if (this.distance.format === 'Эстафета') {
        this.distance.groups.push({
          name: null,
          age_from: null,
          age_to: null,
          age_reference_date: null,
          combination_dict: {},
        })
      }
    },
    updateSport() {
      if (this.distance.related_distances) {
        this.distance.related_distances = this.selectedDistances.map(
          e => e.uuid,
        )
      } else {
        if (
          this.distance.format === 'Эстафета' &&
          this.distance.groups.length > 0
        ) {
          this.transformGroupsFields()
        }
        this.sport.scheme_frame = this.distance.scheme_frame
        this.sport.scheme_image_id = this.distance.scheme_image_id
        this.sport.scheme_image = this.distance.scheme_image
        this.sport.name = this.distance.name
        this.sport.format = this.distance.format
        this.sport.event_date = this.distance.event_date
        this.sport.length_m = this.distance.length_m || null
        this.sport.static_price = this.distance.static_price
        this.sport.description = this.distance.description
        this.sport.date_prices = this.distance.date_prices
        this.sport.stages = this.distance.stages
        this.sport.slots = this.distance.slots
        this.sport.infinite_slots = this.distance.infinite_slots
        this.sport.is_patronymic_required = this.distance.is_patronymic_required
        this.sport.additional_fields = this.distance.additional_fields
        this.sport.discounts = this.distance.discounts
        this.distance.groups = this.distance.groups.map(obj => {
          if (obj.template_id) {
            const { id, ...rest } = obj
            return rest
          }
          return obj
        })
        this.sport.groups = this.distance.groups
      }
      this.distance.is_hidden = this.sport.is_hidden
      this.select_kinds_sport[this.index] = this.distance
      this.$bvModal.hide(`bv-modal-edit${this.index}`)
    },
    updateGroup(group, groupIndex) {
      this.distance.groups[groupIndex] = group
    },
    transformGroupsFields() {
      this.distance.groups.forEach(group => {
        if (group.combination_dict) {
          if (Object.keys(group.combination_dict).length > 0) {
            group.combination_list = []
            for (const combinationDictKey in group.combination_dict) {
              group.combination_list.push({
                stageUUID: combinationDictKey,
                sex:
                  group.combination_dict[combinationDictKey].length > 1 ||
                  !group.combination_dict[combinationDictKey]
                    ? 'Any'
                    : group.combination_dict[combinationDictKey][0],
              })
            }
          }
        }
        delete group.combination_dict
      })
    },
    transformSportGroupsFields() {
      this.sport.groups.forEach(group => {
        if (group.combination_list) {
          group.combination_dict = {}
          group.combination_list.forEach(item => {
            if (item.sex === 'Any') {
              Vue.set(group.combination_dict, item.stageUUID, [
                'Male',
                'Female',
              ])
              // group.combination_dict[item.stageUUID] = ['Male', 'Female']
            } else {
              Vue.set(group.combination_dict, item.stageUUID, [item.sex])
              // group.combination_dict[item.stageUUID] = [item.sex]
            }
          })
        }
      })
    },
    transformSelectedDistances() {
      if (this.sport.related_distances) {
        this.selectedDistances = this.select_kinds_sport.filter(e =>
          this.sport.related_distances.includes(e.uuid),
        )
      }
    },
    addPrices(distance) {
      if (!distance.prices) {
        this.$set(distance, 'prices', [])
      }
      distance.prices.push({
        c_to: '',
        c_from: '',
        value: '',
      })
    },
    deleteGroup(group, indexGroup) {
      if (this.templateGroups.length && group.template_id) {
        const indexDeletedGroup = this.templateGroups.findIndex(
          item =>
            item.template_id === group.template_id && item.id === group.id,
        )
        this.templateGroups.splice(indexDeletedGroup, 1)
      }
      this.distance.groups.splice(indexGroup, 1)
    },
    addField() {
      const uuid = uuidv4()
      this.distance.additional_fields.push({
        name: '',
        type: '',
        uuid,
      })
    },
    updateField(field, fieldIndex) {
      this.distance.additional_fields[fieldIndex] = field
    },
    deleteField(fieldIndex) {
      this.distance.additional_fields.splice(fieldIndex, 1)
    },
    resetModal() {
      this.collapsedStates = {
        participationFormat: false,
        personalGroups: false,
        additionalFields: false,
        discountsEdit: false,
        comboEdit: false,
        discountComboEdit: false,
      }
    },
    restrictEdit(disableDistance) {
      if (disableDistance.groups) {
        this.disabledGroups = disableDistance.groups
      }
      if (disableDistance.stages) {
        this.disabledStages = disableDistance.stages.map(e => e.id)
      }
      if (disableDistance.discounts) {
        this.disabledDiscounts = disableDistance.discounts.map(e => e.id)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.distance_wrapper {
  background-color: #f8f8f8;
  border-radius: 10px;

  padding: 10px;

  /* todo избавиться от important */
  margin-bottom: 1rem !important;

  &:last-child {
    margin-bottom: 0;
  }
}

.distance_format {
  &__input {
    margin-top: 0.5rem;
  }
}

.distance_label {
  display: block;
  font-size: 0.75rem;
}

.distance_form__button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.button-container {
  float: right;
}

.group-buttons {
  display: flex;
}

.distance_double__label {
  font-size: 14px;
  margin-bottom: 0;
}

.distance_input__description {
  margin-bottom: 0.5rem;
}

.distance_form__combo {
  margin-bottom: 1rem;
}

.distance_double__wrapper {
  display: flex;
  align-items: center;
  column-gap: 1rem;
}

.delete-icon {
  cursor: pointer;
  fill: #5e5873;
  transition: fill 0.2s ease;
  /* Плавное изменение цвета */
}

.delete-icon:hover {
  fill: #dc3545;
  /* Красный цвет при наведении */
}

.iframe-preview {
  overflow: hidden;
}

.distance_title {
  display: block;
  margin-bottom: 0.5rem;
}

.add-fille {
  margin: 10px 0;
}

.discount__item-del {
  display: flex;
  align-items: center;
  justify-content: end;
}

.distance {
  margin-top: 30px;
}

.title-format {
  margin: 15px 0 !important;
}

.input__code {
  margin-top: 15px !important;
}

.distances__minus {
  margin-left: 5px;
  transition: 0.3s;

  &:hover {
    cursor: pointer;
    transform: scale(1.1);
  }
}

.sport-block {
  border-bottom: 1px solid #e5e5e5;
}

.z-index {
  z-index: 52011;
}

.price {
  &__title {
    margin-top: 20px;
  }

  &__items {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -15px 20px -15px;
  }

  &__item {
    padding: 20px;
    border: 1px solid #00000012;
    border-radius: 20px;
    position: relative;
    width: calc(50% - 30px);
    margin: 10px 15px 0 15px;

    &-del {
      position: absolute;
      right: 20px;
      top: 10px;
    }
  }
}
</style>
<style>
.flex {
  display: flex;
}

.justify-end {
  justify-content: end;
}

.inline-block {
  display: inline-block;
}

.age {
  display: flex;
}

.age input:last-child {
  margin-left: 30px;
}

.price__item .form-control {
  margin-top: 20px;
}
</style>
